<!-- Recursive template used to render the recursive device structure of categories, sections, and inputs. -->
<div class="cl-device-grouping" fxFill>
    <mat-tab-group dynamicHeight
        class="categoryTabs tab-style-override"
        *ngIf="grouping && grouping.$categories && grouping.$categories.length > 0"
        [(selectedIndex)]="grouping.$selectedCategory"
    >

        <mat-tab *ngFor="let category of this.categories; trackBy: trackByCategoryName">
            <ng-template matTabLabel>
                {{category.categoryName}}
                <mat-icon *ngIf="category.form.invalid" aria-label="Form is not valid!" class="mat-accent error-icon">error</mat-icon>
            </ng-template>
            <div class="settings-contents md-padding">
                <div fxLayout="row wrap">
                    <dl-device-input *ngFor="let input of getInputs(category.$controlInputs)"
                         [ngClass]="input.$inputType"
                         [deviceInfo]="deviceInfo || grouping"
                         [deviceInput]="input"
                         [deviceInputForm]="category.form"
                         [setDeviceInfo]="setDeviceInfo">
                    </dl-device-input>
                </div>

                <dl-device-input [deviceInfo]="deviceInfo || grouping"
                     [deviceInput]="category.$sections"
                     [deviceInputTemplate]="'inputSection'"
                     [displayCount]="category.$sections.length"
                     [deviceInputForm]="category.form"
                     [setDeviceInfo]="setDeviceInfo">
                </dl-device-input>
            </div>
        </mat-tab>
    </mat-tab-group>

    <dl-device-input [deviceInfo]="deviceInfo || grouping"
                      [deviceInput]="grouping.$sections"
                      [deviceInputTemplate]="'inputSection'"
                      *ngIf="grouping"
                      [displayCount]="grouping.$sections.length"
                      [deviceInputForm]="ngForm || deviceInputForm"
                      [setDeviceInfo]="setDeviceInfo">
    </dl-device-input>
</div>
